import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

const state = {
  photoGalleriesList: null,
  photoGalleriesTotalPages: ''
}

const getters = {
  getPhotoGalleries: state => state.photoGalleriesList
}

const actions = {
  async fetchPhotoGalleries ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.photoGallery.getPhotoGalleriesList(), payload)
      commit(types.SET_PHOTO_GALLERIES_LIST, data)
      return data
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail on fetch galleries')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createPhotoGallery ({ dispatch, commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.photoGallery.createPhotoGallery(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Gallery was created successfully')
      await this.dispatch('fetchPhotoGalleries')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail on creating gallery')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editPhotoGallery ({ dispatch, commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.photoGallery.updatePhotoGallery(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Gallery was edited successfully')
      this.dispatch('fetchPhotoGalleries')
      return response.data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Fail on editing gallery')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removePhotoGallery ({ dispatch, commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.photoGallery.deletePhotoGallery(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Gallery was deleted successfully')
      this.dispatch('fetchPhotoGalleries')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Fail on deleting gallery')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }

}

const mutations = {
  [types.SET_PHOTO_GALLERIES_LIST] (state, galleriesData) {
    state.photoGalleriesList = galleriesData.photoGalleries
    state.photoGalleriesTotalPages = galleriesData.totalPages
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/photo-gallery.js